<template>
  <div class="i-css-left">
    <div v-if="usedBy.length" class="used-by">
      <span v-for="(doc, idx) in usedBy" :key="idx">
        <a :href="infoUrl(doc)"
          class="block_link"
          title="Document info"
          data-target="blank" :aria-label="LANG.opensBlank">
          <strong :title="title(doc)">{{title(doc)}}</strong>
        </a>
        <br>
      </span>
    </div>
    <div v-if="!usedBy.length">
      {{ LANG.noReferences }}
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

import globals from '@/globals';

const { uri } = globals.I.Util;

export default defineComponent({
  props: {
    item: Object,
  },
  computed: {
    ...mapState(['LANG']),
    usedBy() {
      if (!this.item) return [];
      return this.item.finished.to;
    },
  },
  methods: {
    title(doc) {
      return doc.copies[0].title || '[Untitled]';
    },
    nodeId(doc) {
      return doc.copies[0].node_id;
    },
    version(doc) {
      return doc.copies[0].version;
    },
    infoUrl(doc) {
      return uri(`/document/oce/info?__imperia_node_id=${this.nodeId(doc)}`);
    },
  },
});
</script>

<style scoped lang='scss'>
a {
  color: $link-color;
}
</style>
